// Function used for header block button if is linking to a form on the same page
// need to add #form in the button field in the URL field (Enter the destination URL) on the CMS
const renderScrollToFormButton = () => {
	const link = document.getElementById("header-block-button");

	if (link && link.getAttribute("href") === "#form") {
		// If the link exists and its href attribute is '#form'
		link.addEventListener("click", function (e) {
			e.preventDefault();

			const targetElement = document.getElementsByClassName("gform_wrapper")[0];
			if (targetElement) {
				targetElement.scrollIntoView({
					behavior: "smooth",
				});
			}
		});
	}
};

export default renderScrollToFormButton;
